import type { UserPreferencesValue } from '@/stores/database/entities/00-RBAC/99-UserPreferences/hooks';

export const PREFERENCE_NOTIFICATION_CHANNELS = ['email', 'inApp', 'push', 'slack'] as const;
export type PreferenceNotificationChannel = (typeof PREFERENCE_NOTIFICATION_CHANNELS)[number];

export const DEFAULT_NOTIFICATION_CHANNELS: Record<PreferenceNotificationChannel, boolean> = {
    email: true,
    inApp: true,
    push: true,
    slack: false,
};

interface NotificationChannelPolicyInput {
    channel: PreferenceNotificationChannel;
    preferences?: UserPreferencesValue | null;
    workflowDefaultEnabled?: boolean;
    workflowKey?: string;
}

export const isNotificationChannelEnabled = ({
    channel,
    preferences,
    workflowDefaultEnabled = true,
    workflowKey,
}: NotificationChannelPolicyInput): boolean => {
    const globallyEnabled = preferences?.notifications?.channels?.[channel] ?? DEFAULT_NOTIFICATION_CHANNELS[channel];
    const workflowEnabled = workflowKey
        ? (preferences?.notifications?.workflows?.[workflowKey]?.[channel] ?? workflowDefaultEnabled)
        : true;

    return globallyEnabled && workflowEnabled;
};
